let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cpXoW")).then(() => parcelRequire('3pHpm'));